module.exports = "//d274d294w9cx2v.cloudfront.net/c537ea05dbae2f7228f714e4c5f18f915f147600/images/photo-single.png";